import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { belongingsConfig } from './configByInsuranceType/belongings';
import { carConfig } from './configByInsuranceType/car';
import { lifeConfig } from './configByInsuranceType/life';
import { productConfig } from './configByInsuranceType/product';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: true,
    showCurrentCapitalValue: true,
    claims: claimsConfig.SK,
    dashboard: dashboardConfig.SK,
    funds: fundsConfig.SK,
    modifications: modificationsConfig.SK,
    servicing: servicingConfig.SK,
    belongings: belongingsConfig.SK,
    car: carConfig.SK,
    life: lifeConfig.SK,
    product: productConfig.SK,
    property: propertyConfig.SK,
    travel: travelConfig.SK,
};
